import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { PPAuthService } from '../../core/services/auth.service';
import { environment } from '../../../environments/environment';
import { Observable, zip, of, Subject, BehaviorSubject, Subscription, combineLatest } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { Real } from '../../core/models/real.model';
import { Booking } from '../../core/models/booking.model';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-done',
  templateUrl: './done.page.html',
  styleUrls: ['./done.page.scss'],
})
export class DonePage implements OnInit {

  booking$: any;
  paid = false;
  noShowProtected = false;
  noProtectionButConfirmed = false;
  loading = false;

  strelec = false;
  real: Real;

  toastRef: any;

  private bookingSubscription: Subscription;

  constructor( 
    private http: HttpClient, 
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private authService: PPAuthService, 
    public toastController: ToastController,
    public translateService: TranslateService
  ) { }

  async presentToast( text ) {
    this.toastRef = await this.toastController.create({
      message: text,
      duration: 10000,
      color: 'danger'
    });
    this.toastRef.present();
  }

  ngOnInit() {}
  
  ionViewWillLeave() { this.bookingSubscription.unsubscribe(); }

  ionViewWillEnter() {

    console.log();


    this.loading = true;
    let bookingId = this.activatedRoute.snapshot.params['bookingId'];

    this.authService.me2$.subscribe( (user) =>  {

      if (user) {
        console.log(user);
        console.log(this.authService.me);
        this.booking$ = this.http.get( environment.apiUrl + '/users/' + this.authService.me.id + '/bookings/' + bookingId + '?expand=provider,bookingselectionitems,bookingproducts');
      
        this.activatedRoute.queryParams

      .subscribe(params => {

        if ( params.paid ) {
          this.paid = true;
        } 

        if ( params.protected ) {
          this.noShowProtected = true;
        }

        this.bookingSubscription = this.booking$.subscribe(

            booking =>  { 

              this.real = new Booking( booking ).getRootReal();

              let onBehalfOfBooker = user.getProviderUserForProviderId(this.real?.provider?.id)?.onBehalfOfBooker ?? false;

              if ( ( booking.paymentRequired && !booking.paid && !onBehalfOfBooker ) || ( booking.noShowProtection && !booking.noShowProtected && !onBehalfOfBooker ) ) {

                this.http.post(
                  environment.apiUrl + '/stripe/checkout', 
                  { bookingId: booking.id }, { observe: 'response' }
                )

                .subscribe( (response: HttpResponse<any>) => {
                  const checkoutUrl = response.headers.get('location');

                  

                  window.location.href = checkoutUrl;
                  this.loading = false;
                  

                  /*this.router.navigate( [ 
                    '/restavracija', 
                    this.activatedRoute.snapshot.params.providerId, 
                    this.activatedRoute.snapshot.params.shopSlug,
                    'rezervacija',
                    'narejena',
                    bookingId
                  ]);*/



                  console.log('navigacija opravljena');
                  
                }, error => {

                  this.loading = false;

                  this.presentToast( 'Nekaj je šlo narobe... Kontaktirajte administratorja.');

                  //this.router.navigate( ['/restavracija', this.activatedRoute.snapshot.params.providerId, this.activatedRoute.snapshot.params.shopSlug, 'rezervacija', 'izberi-termin'] );
                
                }); 


              } else {

                this.loading = false;

                if ( booking.paid ) {
                  this.paid = true;
                }

                if ( booking.noShowProtected ) {
                  this.noShowProtected = true;
                }

                this.noProtectionButConfirmed = true;

              }

            }

          );



        }

        
    );


  }



})





    



  }

  ngOnDestroy() {
    this.bookingSubscription.unsubscribe();
  }

}
